import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { tableHeaderTemplate } from "../../Work Time Log Management/common/TimeLogTemplates";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";
import { ProgressSpinner } from "primereact/progressspinner";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import {
  addFormMapping,
  deleteFormMapping,
  fetchFormMappingList,
  fetchFormsList,
  fetchTeamsList,
  fetchUsersList,
  updateFormMapping,
} from "./fetchData";
import { SUB_MODULES } from "../../../../util/constants";
import { Dropdown } from "primereact/dropdown";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { DeleteIconSVG } from "../../../../assets/SVGs/DeleteIconSVG";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DeletePopupTrashIcon } from "../../../../assets/SVGs/DeletePopupTrashIcon";
import { InputText } from "primereact/inputtext";
import FilterButton from "../../Work Time Log Management/common/FilterButton";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";

const HsFormMapping = () => {
  const menu = useRef<Menu>(null);
  const toast = useRef<Toast>(null);

  const [formMappingListingDataLoading, setFormMappingListingDataLoading] =
    useState<boolean>(false);
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [teamsList, setTeamsList] = useState<any>([]);
  const [expandedRows, setExpandedRows] = useState<any>([]);
  const [show, setShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [selectedForms, setSelectedForms] = useState<any>(null);
  const [selectedTeam, setSelectedTeam] = useState<any>(null);
  const [isAreaManager, setIsAreaManager] = useState<boolean>(false);
  const [formList, setFormList] = useState<any>([]);
  const [usersList, setUsersList] = useState<any>([]);
  const [formMappingListingData, setFormMappingListingData] = useState<any>([]);
  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    useState<boolean>(false);
  const [deleteReason, setDeleteReason] = useState<string>("");
  const [deleteReasonError, setDeleteReasonError] = useState<string | null>(
    null
  );
  const [formMappingID, setFormMappingID] = useState<any>(null);
  const [formType, setFormType] = useState<string>("add");
  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);
  const [statusChangeActivity, setStatusChangeActivity] = useState<any>([]);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [formErrors, setFormErrors] = useState<any>({
    user: null,
    form: null,
    team: null,
  });

  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "formDate",
    sortOrder: true,
  });

  const [filters, setFilters] = useState<any>({
    user: null,
  });

  useEffect(() => {
    fetchUsersList(setUsersList, toast);
    fetchFormsList(setFormList, toast);
    fetchTeamsList(setTeamsList, toast);
    fetchFormMappingList(
      setFormMappingListingData,
      setFormMappingListingDataLoading,
      filters,
      toast
    );
  }, [filters?.user]);

  const clearFilters = () => {
    setFilters((prevFilter: any) => ({
      ...prevFilter,
      user: null,
    }));
  };

  const items = [
    {
      items: [
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-3">
              <label htmlFor="name" className="tw-font-semibold">
                User
              </label>
              <MultiSelect
                className="tw-h-11 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal filter-dropdown"
                value={filters?.user ?? null}
                options={usersList} //users list
                optionLabel="displayName" // Assuming 'roles' contains an array of objects with a 'role' key
                placeholder="Select Users"
                onChange={(e) => {
                  setFilters((prevFilters: any) => ({
                    ...prevFilters,
                    user: e.value,
                  }));
                }}
                filter
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-red-500 hover:tw-bg-red-500 tw-font-medium tw-gap-2 tw-text-white"
                onClick={clearFilters} // This function will reset filters
              >
                Clear Filters
              </Button>
            </div>
          ),
        },
      ],
    },
  ];

  const validateForm = () => {
    const errors: Partial<Record<string, string>> = {};

    if (!selectedUser || selectedUser.length === 0) {
      errors.user = "Please select at least one user.";
    }
    if (!selectedForms || selectedForms.length === 0) {
      errors.form = "Please select at least one form.";
    }
    if (
      selectedForms?.find(
        (form: any) => form.sub_module_name === SUB_MODULES.LEAK_DETECTION
      ) &&
      !selectedTeam
    ) {
      errors.team = "Please select a team.";
    }
    // if (
    //   selectedForms?.find(
    //     (form: any) => form.sub_module_name === SUB_MODULES.LEAK_DETECTION
    //   ) &&
    //   selectedTeam &&
    //   !isAreaManager
    // ) {
    //   errors.isAreaManager = "Please select if the user is an area manager.";
    // }
    setFormErrors((prev: any) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    if (formType === "add") {
      addFormMapping(
        selectedUser,
        setSelectedUser,
        selectedForms,
        setSelectedForms,
        selectedTeam,
        setSelectedTeam,
        isAreaManager,
        setIsAreaManager,
        setShow,
        setIsFormSubmitting,
        toast
      ).then(() => {
        // Refresh the form mapping listing data after saving
        fetchFormMappingList(
          setFormMappingListingData,
          setFormMappingListingDataLoading,
          filters,
          toast
        );
      });
    } else if (formType === "update") {
      updateFormMapping(
        formMappingID,
        selectedUser,
        setSelectedUser,
        selectedForms,
        setSelectedForms,
        selectedTeam,
        setSelectedTeam,
        isAreaManager,
        setIsAreaManager,
        setShow,
        setIsFormSubmitting,
        toast
      ).then(() => {
        // Refresh the form mapping listing data after updating
        fetchFormMappingList(
          setFormMappingListingData,
          setFormMappingListingDataLoading,
          filters,
          toast
        );
      });
    }
  };

  const handleEditFormMapping = (rowData: any) => {
    // Logic to handle editing the form mapping
    setFormMappingID(rowData.id);
    setFormType("update");
    const user = usersList.find((user: any) => user.userID === rowData.userID);
    if (user) {
      // Set the selected user as an array
      setSelectedUser([user]);
    } else {
      setSelectedUser([]);
    }
    const form = formList.find(
      (form: any) => form.sub_module_name === rowData.sub_module_name
    );
    if (form) {
      // Set the selected forms as an array
      setSelectedForms([form]);
    } else {
      setSelectedForms([]);
    }
    // Uncomment and fix if you want to support team selection
    if (rowData.teamID) {
      const team = teamsList.find((team: any) => team.id === rowData.teamID);
      setSelectedTeam(team);
    }
    setShow(true);
  };

  // Custom error template (can also include icons or custom components)
  const emptyMessageTemplate = (
    <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
      <h4>No records found.</h4>
    </div>
  );

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-UK", { month: "short" });
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const events: any = statusChangeActivity?.map((activity: any) => ({
    actionTakerID: activity?.actionTakerID,
    date: activity?.createdDate,
    actionTakerDisplayName: activity?.actionTakerName,
    comment: activity?.statusChangeReason,
    action:
      activity?.previousStatus === "ACTIVE" ? "Record Deleted" : "Record Added",
    id: activity?.id,
  }));

  const customizedMarker = () => (
    <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
      <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
    </div>
  );

  const customizedContent = (item: any) =>
    item?.action ? (
      <Card className="activity-card tw-bg-gray-50">
        <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
          <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {formatCreatedDate(item?.date)}
          </span>
        </div>
        <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          <span>
            <span className="tw-font-medium tw-text-gray-700">
              {item?.action}
            </span>{" "}
            <span className="tw-text-gray-600">
              by {item?.actionTakerDisplayName}
            </span>
          </span>
        </span>
        <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
          <span className="tw-ml-auto">{item?.comment}</span>
        </div>
      </Card>
    ) : (
      <div>No History Found</div>
    );

  const actionBodyTemplate = (rowData: any) => (
    <div className="tw-flex tw-gap-4">
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => handleEditFormMapping(rowData)}
      >
        <EditButtonSVG />
      </Button>
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => {
          setFormMappingID(rowData.id);
          setIsConfirmDeleteDialogOpen(true);
        }}
      >
        <DeleteIconSVG />
      </Button>
      <i
        className="pi pi-info-circle tw-text-[#00AFEE] tw-text-xl "
        title="View Status History"
        onClick={() => {
          setSelectedRowData(rowData);
          setStatusChangeActivity(rowData?.userHsFormStatusChangeHistory || []);
          setViewHistoryPopup(true);
        }}
      />
    </div>
  );

  const handleDelete = async () => {
    if (!deleteReason.trim()) {
      setDeleteReasonError("Please provide a reason for deleting this record");
      return;
    }
    deleteFormMapping(
      formMappingID,
      setFormMappingListingData,
      setFormMappingListingDataLoading,
      setIsConfirmDeleteDialogOpen,
      setIsDeleting,
      filters,
      toast,
      deleteReason
    ).then(() => {
      // Refresh the form mapping listing data after deletion
      fetchFormMappingList(
        setFormMappingListingData,
        setFormMappingListingDataLoading,
        filters,
        toast
      );
      setDeleteReason("");
      setDeleteReasonError(null);
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <div className=" tw-bg-[#F8FAFC] tw-border-solid tw-border tw-border-[#E2E8F0] tw-rounded-lg">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4 tw-p-4 tw-gap-2 tw-flex-wrap">
          <h2 className="tw-text-xl tw-font-semibold">Form Mapping</h2>
          <div className="tw-flex tw-gap-2 tw-items-center tw-justify-end tw-flex-wrap">
            <FilterButton menu={menu} />
            <Menu
              className="tw-w-80"
              model={items as MenuItem[]}
              popup
              ref={menu}
            />
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
              label="Add"
              icon="pi pi-plus"
              onClick={() => {
                setShow(true);
                setFormType("add");
                setSelectedUser(null);
                setSelectedForms(null);
                setSelectedTeam(null);
                setIsAreaManager(false);
              }}
            />
          </div>
        </div>
        <ConfirmDialog
          group="headless"
          visible={isConfirmDeleteDialogOpen}
          onHide={() => {
            setIsConfirmDeleteDialogOpen(false);
            setDeleteReason("");
            setDeleteReasonError(null);
          }}
          message={
            <div className="tw-flex tw-flex-col tw-w-full tw-gap-4">
              <div className="tw-flex tw-flex-align-items-center tw-w-full tw-gap-3 tw-border-bottom-1 tw-surface-border">
                <DeletePopupTrashIcon />
                <div className="tw-flex tw-flex-col">
                  <span className="tw-text-2xl tw-font-bold tw-text-black">
                    Confirmation
                  </span>
                  <span className="tw-text-lg">
                    Are you sure you want to delete this record?
                  </span>
                </div>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2">
                <label className="tw-font-semibold">Reason for deletion</label>
                <InputText
                  value={deleteReason}
                  onChange={(e) => {
                    setDeleteReason(e.target.value);
                    setDeleteReasonError(null);
                  }}
                  placeholder="Enter reason..."
                  className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal ${
                    deleteReasonError ? "tw-border-red-500" : ""
                  }`}
                />
                {deleteReasonError && (
                  <small className="tw-text-red-500">{deleteReasonError}</small>
                )}
              </div>
            </div>
          }
          footer={() => (
            <div className="flex gap-2">
              <Button
                onClick={() => {
                  setIsConfirmDeleteDialogOpen(false);
                  setDeleteReason("");
                  setDeleteReasonError(null);
                }}
                className="tw-rounded-lg tw-border tw-border-gray-300 tw-px-4 focus:tw-shadow-none hover:tw-bg-gray-200 tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                className="tw-bg-primary hover:tw-bg-[#152846] tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-ml-2 tw-font-medium tw-transition-all tw-duration-200"
                disabled={isDeleting}
              >
                Delete
              </Button>
            </div>
          )}
        >
          <div className="tw-flex tw-justify-start tw-items-start tw-gap-4 tw-w-full">
            <div className="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
                  stroke="#9C1C21"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
              <h1 className="delete-title"> Confirmation</h1>
              <p className="delete-message">
                Are you sure you want to approve this leave?
              </p>
            </div>
          </div>
        </ConfirmDialog>
        {formMappingListingDataLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={formMappingListingData}
            emptyMessage={emptyMessageTemplate}
            rowGroupMode="subheader"
            groupRowsBy="sub_module_name"
            expandableRowGroups
            expandedRows={expandedRows}
            onRowToggle={(e: DataTableRowToggleEvent) => {
              setExpandedRows(e.data);
            }}
            tableStyle={{ minWidth: "50rem" }}
            // className="leak-detection-table "
            rowGroupHeaderTemplate={(data: any) => {
              return (
                <div className="tw-inline-flex tw-justify-between tw-items-center tw-gap-3 table-row-group-header tw-bg-[#F8FAFC] tw-pl-2 tw-tex tw-font-semibold tw-text-base tw-text-gray-900">
                  {data.sub_module_name}
                </div>
              );
            }}
            rowClassName={() =>
              "hover:tw-bg-[#E8F9FF] tw-cursor-pointer tw-text-[#64748B]"
            }
            className="a-table timelog-datatable tw-text-nowrap tw-text-sm tw-text-[#64748B]"
            style={{ backgroundColor: "#000 !important" }}
          >
            <Column
              field="displayName"
              header={tableHeaderTemplate("User", "", setSortFilter)}
              body={(rowData) => (
                <span className="tw-text-[#3d4c61] tw-text-base tw-font-medium">
                  {rowData.displayName || "-"}
                </span>
              )}
            />
            <Column
              field="teamName"
              header={tableHeaderTemplate("Team Name", "", setSortFilter)}
              body={(rowData) => (
                <span className="tw-text-[#3d4c61] tw-text-base tw-font-medium">
                  {rowData.sub_module_name === SUB_MODULES.LEAK_DETECTION
                    ? rowData.teamName
                    : ""}
                </span>
              )}
            />
            <Column
              field="action"
              header={tableHeaderTemplate("Action", "", setSortFilter)}
              body={actionBodyTemplate}
            />
          </DataTable>
        )}
        {/* Modal */}
        <Dialog
          header={`${formType === "add" ? "Add" : "Update"} Form Mapping`}
          // breakpoints={{ "960px": "75vw", "640px": "90vw" }}
          visible={show}
          style={{ width: "20vw" }}
          className="tw-rounded-2xl"
          onHide={() => {
            setShow(false);
            setSelectedUser(null);
            setSelectedForms(null);
            setSelectedTeam(null);
            setIsAreaManager(false);
            setFormErrors({
              user: null,
              form: null,
              team: null,
            });
            setFormType("add");
          }}
          closable
          closeOnEscape
          blockScroll
          draggable={false}
          modal
        >
          <div className="tw-flex tw-flex-col">
            <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
              <label className="tw-mt-3 tw-font-bold">Select User</label>
              {formType === "add" ? (
                <MultiSelect
                  value={selectedUser || []}
                  options={usersList}
                  disabled={isFormSubmitting}
                  onChange={(e) => {
                    setSelectedUser(e.value);
                    setFormErrors((prev: any) => ({
                      ...prev,
                      user: null, // Reset error when user changes
                    }));
                  }}
                  showSelectAll
                  maxSelectedLabels={2}
                  selectAllLabel="Select All"
                  placeholder="Select a User"
                  optionLabel="displayName"
                  className={`tw-border tw-border-solid ${
                    formErrors.user ? "tw-border-red-600" : "tw-border-gray-300"
                  }  tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                  filter
                />
              ) : (
                <>
                  <InputText
                    type="text"
                    // className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#202022] tw-h-11 tw-w-full lg:tw-w-[370px]"
                    className={`tw-pl-3 tw-border tw-border-solid ${
                      formErrors.user
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    }  tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-h-11 tw-w-full`}
                    value={
                      selectedUser && selectedUser[0]?.displayName
                        ? selectedUser[0].displayName
                        : ""
                    }
                    readOnly
                  />
                </>
              )}
            </div>

            <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
              <label className="tw-mt-3 tw-font-bold">Form</label>
              <MultiSelect
                value={selectedForms || []}
                options={formList}
                onChange={(e) => {
                  if (
                    selectedForms &&
                    Array.isArray(selectedForms) &&
                    !e.value.some(
                      (form: any) =>
                        form.sub_module_name === SUB_MODULES.LEAK_DETECTION
                    )
                  ) {
                    setSelectedTeam(null);
                  }
                  setSelectedForms(e.value);
                  setFormErrors((prev: any) => ({
                    ...prev,
                    form: null, // Reset error when form changes
                  }));
                }}
                showSelectAll
                maxSelectedLabels={1}
                selectAllLabel="Select All"
                placeholder="Select a Form"
                optionLabel="sub_module_name"
                className={`tw-border tw-border-solid ${
                  formErrors.form ? "tw-border-red-600" : "tw-border-gray-300"
                }  tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                filter
              />
            </div>
            {selectedForms?.find(
              (form: any) => form.sub_module_name === SUB_MODULES.LEAK_DETECTION
            ) && (
              <>
                <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-mt-3 tw-font-bold">Team</label>
                  <Dropdown
                    value={selectedTeam || []}
                    options={teamsList}
                    onChange={(e) => {
                      setSelectedTeam(e.value);
                      setFormErrors((prev: any) => ({
                        ...prev,
                        team: null, // Reset error when team changes
                      }));
                    }}
                    placeholder="Select a Team"
                    optionLabel="name"
                    className={`tw-border  ${
                      formErrors.team
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    }  tw-border-solid  tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                    // required
                    filter
                  />
                </div>
                {/* <div className="tw-mt-3 tw-flex tw-items-center tw-gap-2">
                  <Checkbox
                    inputId="isAreaManager"
                    checked={isAreaManager || false}
                    onChange={(e) => setIsAreaManager(!!e.checked)}
                    variant="filled"
                    className="tw-form-checkbox tw-border-black tw-h-4 tw-w-6 tw-text-primary"
                  />
                  <label
                    htmlFor="isAreaManager"
                    className="tw-font-bold tw-mt-1"
                  >
                    Is Area Manager
                  </label>
                </div> */}
              </>
            )}
            <Button
              onClick={handleSave}
              label={`${isFormSubmitting ? "Saving..." : "Save"}`}
              loading={isFormSubmitting}
              disabled={isFormSubmitting}
              className="tw-flex tw-px-3 tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
            />
          </div>
        </Dialog>

        <Dialog
          header={`Status Change History for ${
            selectedRowData?.displayName || "Form Mapping"
          }`}
          visible={viewHistoryPopup}
          style={{ width: "22vw" }}
          onHide={() => setViewHistoryPopup(false)}
          closable
          className="activity-Dialog"
        >
          <div className="timeline-container">
            {statusChangeActivity && statusChangeActivity.length !== 0 ? (
              <Timeline
                value={events}
                align="left"
                className="customized-timeline"
                marker={customizedMarker}
                content={customizedContent}
              />
            ) : (
              <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
                <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                  No History Found
                </p>
              </div>
            )}
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default HsFormMapping;
